import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { sanitizeHtml } from "../../utils/sanitizeHtml";

const KeyFeatures = ({ ...props }) => {
  const [featuresData, setFeaturesData] = useState([]);
  const [featuresLoading, setFeaturesLoading] = useState(true);

  useEffect(() => {
    setFeaturesLoading(false);
    setFeaturesData(props.features);
  }, [props.features]);

  return (
    <>
      <div className="max-w-md p-5 max-w-full bg-white shadow rounded-lg mb-5">
        <div>
          <h2 className="text-gray-800 text-sm font-bold leading-snug mb-3 text-center">
            Key Features
          </h2>

          {featuresLoading || (
            <>
              {featuresData?.map((data, index) => (
                <div className="" key={index}>
                  <div className="grid grid-cols-6 gap-4 mt-5">
                    <div className="covered-image covered-image-white">
                      <img
                        src={data.imageUrl}
                        alt="key-features"
                        className="covered-icon"
                      />
                    </div>
                    <div key={index} className="self-center col-span-5">
                      <h5 className="ml-3 font-semibold mb-1 text-sm leading-tight">
                        {data.title}   
                      </h5>

                      <p className="text-gray-600 text-xs leading-snug ml-3" dangerouslySetInnerHTML={{ __html: sanitizeHtml(data.description) }}>
                      </p>
                    </div>
                  </div>
                  <div className="grid grid-cols-6 gap-4">
                    <div className="self-center">
                    </div>
                    {/* BULLETED ITEMS */}
                    <div className="self-center col-span-5"> 
                      {
                        (data.item !== undefined && data.item !== null && data.item.length > 0) && (
                          <ul className="ml-3 font-semibold mb-1 text-sm leading-tight">
                            {
                              data.item?.map((item, itemIndex) => (
                                <li key={itemIndex} className="list-disc">{item}</li>
                              ))
                            }
                          </ul>
                        )
                      }
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default KeyFeatures;
